import React, { useState } from "react";
import { OutlinedInput } from "@material-ui/core";

const formatCurrency = (value) => {
    if (value == null || value === '') return '';
    const number = Number(value);
    if (isNaN(number)) return value;
    return `$${number.toLocaleString("en-US")}`;
};

const CustomNumberInputField = (props) => {
    const { classes, element, dataObj, onChange, styles } = props;

    const key = element.value || element.name;
    const rawValue = dataObj[key] ?? '';
    const [isEditing, setIsEditing] = useState(false);
    const [inputValue, setInputValue] = useState(rawValue);

    const handleFocus = () => {
        if (element.showIcon) {
            setIsEditing(true);
            setInputValue(rawValue);
        }
    };

    const handleBlur = () => {
        if (element.showIcon) {
            setIsEditing(false);
            onChange(key, inputValue, element.type);
        }
    };

    const handleChange = (e) => {
        let val = e.target.value;
        if (element.showIcon) {
            val = val.replace(/[^0-9]/g, '');
            setInputValue(val);
        } else {
            onChange(key, val, element.type);
        }
    };

    const valueToDisplay = () => {
        if (element.showIcon) {
            return isEditing ? inputValue : formatCurrency(rawValue);
        } else {
            return rawValue;
        }
    };

    return (
        <OutlinedInput
            id={element.name}
            variant="outlined"
            className={classes.inputField}
            style={styles || {}}
            required={element.required}
            key={key}
            name={key}
            disabled={element.readOnly}
            type="text"
            value={valueToDisplay()}
            title={valueToDisplay()}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
        />
    );
};

export default CustomNumberInputField;
